import type { ActivityModule } from '../../core/activity';
import { mountGraduatedLineRead } from './ui';
import levelsData from './levels.json';
import '../graduated_line_use/style.css';
import './style.css';

export const graduatedLineRead: ActivityModule = {
  id: 'graduated_line_read',
  title: 'Leia a régua',
  description: 'Olhe onde a flecha aponta e digite o valor correspondente na régua graduada.',
  ageMin: 6,
  ageMax: 10,
  difficulty: 1,
  iconPath: 'assets/gcompris-AGPL/graduated_line_read/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountGraduatedLineRead,
};
